import { render, staticRenderFns } from "./SmartBonesInnovation.vue?vue&type=template&id=9867642a&scoped=true"
import script from "./SmartBonesInnovation.vue?vue&type=script&lang=js"
export * from "./SmartBonesInnovation.vue?vue&type=script&lang=js"
import style0 from "./SmartBonesInnovation.vue?vue&type=style&index=0&id=9867642a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9867642a",
  null
  
)

export default component.exports